// Native
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"

// Components
import { Avatar, ButtonGroup, HStack, Tag, Td, Text } from "@chakra-ui/react"
import { Container, Searchable, Table, Heading, IconButton, Row, Dash, Dev } from "components"

// Config
import { Moment } from "config"

// Hooks
import { useConsultants } from "hooks"
import { Enums } from "config"

export default function Consultants(){

    const navigate = useNavigate()
    const [ term, setTerm ] = useState(null)
    const [ page, setPage ] = useState(1)
    const consultants = useConsultants(page, term)

    const columns = [
        { title: '' },
        { title: 'Consultor:' },
        { title: 'Cidade:' },
        { title: 'Perfil:' },
        { title: 'Cadastro:', isNumeric: true }
    ]

    // Toda vez que alterar o termo de busca, volta para a página 1
    useEffect(() => { setPage(1) }, [term])

    return(
        <Container>

            <Heading title="Consultores">
                <ButtonGroup size="xs">
                    <IconButton icon="refresh" isLoading={consultants.isFetching} onClick={consultants.refetch} />
                    <Dev data={consultants} />
                </ButtonGroup>
            </Heading>

            <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por ID, Código, Nome, E-mail ou CPF..." />

            <Table columns={columns} meta={consultants?.data?.meta} loading={consultants.isLoading} setPage={setPage} >
                {consultants.data?.data?.map(item => !!item?.customer && <Item key={item.id} data={item} onClick={() => navigate(`/consultants/${item?.id}`)} />)}
            </Table>
        </Container>
    )
}

const Item = ({ data:item, ...props }) => (
    <Row {...props}>
        <Td children={item.cod} />
        <Td textTransform="capitalize" fontWeight="bold"><HStack><Avatar size="xs" name={item?.customer?.name} src={item.customer?.avatar_url} /> <Text children={item?.customer?.name} /></HStack></Td>
        <Td>🗺️ <Dash children={item?.customer?.city && `${item?.customer?.city?.name}, ${item?.customer?.city?.state_code}`} /></Td>
        <Td>
            <HStack spacing={2}>
                <Tag size="sm" children={item.career?.current_career?.title ?? 'Consultor'} />
                <Tag size="sm" colorScheme={Enums.ActiveMonthStatus.data(item.active_month_status).colorScheme} children={item.active_month_status_label} />
            </HStack>
        </Td>
        <Td isNumeric children={Moment(item.created_at).calendar()} />
    </Row>
)